import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ModalController, IonButton, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonTitle, IonToolbar } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";
import { ImagePosition } from "../../enum/enumImagePosition";
import { PlatformModeContentDirective } from "../../../../directive/platform-mode-content.directive";
import { ColorPickerDirective } from "ngx-color-picker";
import { MdSelectDirective } from "../../../../directive/md-select.directive";

@Component({
    selector: "app-supervision-widget-settings",
    templateUrl: "./supervision-widget-settings.component.html",
    styleUrls: ["./supervision-widget-settings.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonTitle, IonToolbar, PlatformModeContentDirective, ColorPickerDirective, MdSelectDirective, FormsModule, ReactiveFormsModule, TranslatePipe]
})
export class SupervisionWidgetSettingsComponent {
  private readonly _modalCtrl = inject(ModalController);

  @Input() textPosition: ImagePosition = ImagePosition.LEFT;
  @Input() showText: boolean = true;
  @Input() textColor: string = "#000000";
  @Input() rotationIcon: number = 0;
  @Input() zoom: number = 100;

  public zoomFormControl = new FormControl(100, Validators.compose([Validators.required, Validators.min(50), Validators.max(200)]));
  public rotationIconFormControl = new FormControl(0, Validators.compose([Validators.required, Validators.min(0), Validators.max(360)]));

  ngOnInit() {
    this.zoomFormControl.setValue(this.zoom);
    this.rotationIconFormControl.setValue(this.rotationIcon);
  }

  /**
   * Change position of image and text
   */
  public onClickSaveData(): void {
    this._modalCtrl.dismiss({
      textPosition: this.textPosition,
      showText: this.showText,
      textColor: this.textColor,
      rotationIcon: this.rotationIconFormControl.value,
      zoom: this.zoomFormControl.value
    });
  }

  /**
   * Set the value of a particular variable on ionChange event
   * @param variable name of the variable
   * @param event ionChange event
   */
  public onChangeSetValue(variable: string, event: Event): void {
    this[variable] = (event as CustomEvent).detail.value;
  }

  /**
   * Exit without choosing an option
   */
  public onClickCancel(): void {
    this._modalCtrl.dismiss();
  }

  /**
   * Save color value got from picker
   * @param colorString color got from picker
   */
  public onCloseSaveColorValue(colorString: string) {
    this.textColor = colorString;
  }


}
